import React from "react";
import * as Styles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { BnbLabel } from "../../../../utils/labels";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { MODAL_FINANCE_DISCLAIMER } from "../../../../../../../common-deprecated/utils/modalConstants";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { formatInsurancePrice } from "../../../../../../shared-logic/utils/insuranceUtils";
import { AemFmComponent } from "../../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

type InsurancePriceType = {
    showLoader?: boolean;
    forceHideDisclaimer?: boolean; // Used when the MonthlyRateDisclaimer needs to be shown in different location, see InsuranceService
};

const InsurancePrice = (props: InsurancePriceType): JSX.Element | null => {
    const { showLoader, forceHideDisclaimer } = props;

    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const insurance = useBnbSelector((state) => state.insuranceRate);
    const modelCode = useBnbSelector((state) => state.car.model?.internalCode);
    const { showMonthlyRateDisclaimerInline, showFinanceInsuranceInPage, enableFinanceCompare } = useBnbSelector(
        (state) => state.bnbSettings,
    );
    const commonSettings = useBnbSelector((state) => state.commonSettings);

    const formattedPrice = formatInsurancePrice(
        insurance,
        AemFmComponent.Build,
        commonSettings,
        showMonthlyRateDisclaimerInline,
        modelCode,
    );

    if (showLoader && insurance.fetching) {
        return (
            <Styles.Text>
                <BnbLabel label="priceLoading" fallbackLabel="spinLoading" />
            </Styles.Text>
        );
    }

    if (insurance.fetching) return null;
    return (
        <>
            {formattedPrice.labels.map((item, index) => (
                <div key={item.key} className="mb-1">
                    {showFinanceInsuranceInPage || enableFinanceCompare ? (
                        <Type.SmallText
                            dangerouslySetInnerHTML={{ __html: item.value }}
                            color={index > 0 ? "grey4" : undefined}
                        />
                    ) : (
                        <Styles.Text dangerouslySetInnerHTML={{ __html: item.value }} />
                    )}
                </div>
            ))}

            {!forceHideDisclaimer && formattedPrice.disclaimerParts.length > 0 && (
                <Button.Link
                    hasIconRight
                    onClick={(event) => {
                        event.stopPropagation();
                        if (insurance.info?.disclaimer) {
                            dispatch(
                                showModal({
                                    type: MODAL_FINANCE_DISCLAIMER,
                                    disclaimer: insurance.info.disclaimer,
                                    productName: "",
                                }),
                            );
                        }
                    }}
                >
                    <Type.SmallText
                        dangerouslySetInnerHTML={{ __html: formattedPrice.disclaimerParts[0] }}
                        color="dark"
                    />
                    {(showFinanceInsuranceInPage || enableFinanceCompare) && (
                        <IconWrapper>
                            <Icon variant="arrowRight" />
                        </IconWrapper>
                    )}
                    {formattedPrice.disclaimerParts.length > 1 && (
                        <IconWrapper>
                            <Icon variant="info" />
                        </IconWrapper>
                    )}
                    {formattedPrice.disclaimerParts.length > 1 && (
                        <span dangerouslySetInnerHTML={{ __html: formattedPrice.disclaimerParts[1] }} />
                    )}
                </Button.Link>
            )}
        </>
    );
};

export default InsurancePrice;
